export default "__VITE_ASSET__D2ly51Ly__"